const newArray = (length = 0) => {
    return [...Array(length).keys()];
};

export default newArray;